function getCartUrl() {
  console.log('[Cart] getCartUrl() called');

  if (window.routes && window.routes.cart_url) {
    console.log('[Cart] Using window.routes.cart_url:', window.routes.cart_url);
    return window.routes.cart_url;
  }

  console.log('[Cart] window.routes.cart_url not found. Using fallback: /cart');
  return '/cart';
}

  function updateHeaderCartCount(cartData) {
    const count = cartData && typeof cartData.item_count === 'number' ? cartData.item_count : 0;
    const countBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');

    if (count === 0) {
      countBubble?.remove();
      document.getElementById('cart-icon-bubble')?.setAttribute('aria-label', 'Cart, 0');
      return;
    }

    if (countBubble) {
      countBubble.innerHTML = `<span>${count}</span>`;
      countBubble.setAttribute('aria-hidden', 'true');
      document.getElementById('cart-icon-bubble')?.setAttribute('aria-label', `Cart, ${count}`);
      return;
    }

    const cartIconButton = document.getElementById('cart-icon-bubble');
    if (cartIconButton && count > 0) {
      const bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.setAttribute('aria-hidden', 'true');
      bubble.innerHTML = `<span>${count}</span>`;
      cartIconButton.setAttribute('aria-label', `Cart, ${count}`);
      cartIconButton.appendChild(bubble);
    }
  }

function replaceCartDrawer(sectionHtml) {

  const parsedDocument = new DOMParser().parseFromString(sectionHtml, 'text/html');
  const newDrawer = parsedDocument.querySelector('cart-drawer');
  const currentDrawer = document.querySelector('cart-drawer');


  if (!newDrawer || !currentDrawer) {
    console.warn('[Cart] Cannot replace drawer - missing drawer element');
    return;
  }

  const wasOpen = currentDrawer.classList.contains('active');

  currentDrawer.className = newDrawer.className;
  currentDrawer.innerHTML = newDrawer.innerHTML;


  syncCartDrawerOverlay(currentDrawer);

  if (wasOpen) {
    currentDrawer.classList.add('active');
    document.body.classList.add('overflow-hidden');
    if (typeof currentDrawer.trapDrawerFocus === 'function') {
      currentDrawer.trapDrawerFocus();
    } else if (typeof currentDrawer.open === 'function') {
      currentDrawer.open(currentDrawer.activeElement);
    }
  }

  console.log('[Cart] replaceCartDrawer() completed');
  window.announceCartUpdated?.();
}

function syncCartDrawerOverlay(cartDrawer) {
  console.log('[Cart] syncCartDrawerOverlay() called');

  const overlay = cartDrawer && cartDrawer.querySelector('#CartDrawer-Overlay');

  console.log('[Cart] Overlay found:', !!overlay);
  console.log(
    '[Cart] cartDrawer.close available:',
    !!cartDrawer && typeof cartDrawer.close === 'function'
  );

  if (!overlay || typeof cartDrawer.close !== 'function') {
    console.warn('[Cart] Cannot sync overlay');
    return;
  }

  overlay.onclick = cartDrawer.close.bind(cartDrawer);

  console.log('[Cart] Overlay click handler attached');
}

async function refreshCartDrawer() {
  console.log('[Cart] refreshCartDrawer() called');
  console.log('[Cart] refreshInFlightMini:', refreshInFlightMini);

  if (refreshInFlightMini) {
    console.log('[Cart] Refresh already in progress. Skipping.');
    return;
  }

  refreshInFlightMini = true;

  console.log('[Cart] Refresh started');

  try {
    const cartUrl = getCartUrl();

    console.log('[Cart] Fetching cart drawer:', `${cartUrl}?section_id=cart-drawer`);
    console.log('[Cart] Fetching cart data:', '/cart.js');

    const [drawerResponse, cartResponse] = await Promise.all([
      fetch(`${cartUrl}?section_id=cart-drawer`, { cache: 'no-store' }),
      fetch('/cart.js', { cache: 'no-store' }),
    ]);

    console.log('[Cart] Drawer response:', {
      ok: drawerResponse.ok,
      status: drawerResponse.status,
      statusText: drawerResponse.statusText,
    });

    console.log('[Cart] Cart response:', {
      ok: cartResponse.ok,
      status: cartResponse.status,
      statusText: cartResponse.statusText,
    });

    if (drawerResponse.ok) {
      console.log('[Cart] Reading drawer HTML');

      const drawerHtml = await drawerResponse.text();

      console.log('[Cart] Drawer HTML received. Length:', drawerHtml.length);

      replaceCartDrawer(drawerHtml);
    } else {
      console.warn('[Cart] Drawer request failed');
    }

    if (cartResponse.ok) {
      console.log('[Cart] Reading cart JSON');

      const cartData = await cartResponse.json();

      console.log('[Cart] Cart data:', cartData);
      console.log('[Cart] Cart item count:', cartData.item_count);
      console.log('[Cart] Cart total:', cartData.total_price);

      updateHeaderCartCount(cartData);

      console.log('[Cart] Header cart count updated');
    } else {
      console.warn('[Cart] Cart JSON request failed');
    }

    const cartDrawer = document.querySelector('cart-drawer');

    console.log('[Cart] Final cart drawer found:', !!cartDrawer);

    if (cartDrawer) {
      console.log('[Cart] Final drawer active:', cartDrawer.classList.contains('active'));
      console.log('[Cart] cartDrawer.open available:', typeof cartDrawer.open === 'function');
    }

    if (
      cartDrawer &&
      !cartDrawer.classList.contains('active') &&
      typeof cartDrawer.open === 'function'
    ) {
      console.log('[Cart] Opening cart drawer');
      cartDrawer.open(document.activeElement);
    }

    console.log('[Cart] refreshCartDrawer() completed successfully');
  } catch (error) {
    console.error('[Cart] Error refreshing cart drawer:', error);
  } finally {
    refreshInFlightMini = false;
    console.log('[Cart] Refresh lock released');
  }
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.defaultSubmitButtonText = this.submitButtonText.textContent;

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.adding) return;

        this.handleErrorMessage();

        const stickySubmitButtonText = document.querySelector('#sticky-atc-wrapper .sticky-atc-button__text');
        const defaultStickySubmitButtonText = stickySubmitButtonText?.textContent;
        // Block double submits with a flag: aria-disabled on the focused button makes NVDA say "unavailable".
        this.adding = true;
        this.submitButtonText.textContent = window.variantStrings.addingToCart;
        this.querySelector('.loading__spinner').classList.add('hidden');
        if (stickySubmitButtonText) stickySubmitButtonText.textContent = window.variantStrings.addingToCart;

        // custom.js skips its Wiser-triggered drawer refresh while this is recent.
        window.distaThemeCartChangeAt = Date.now();
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const cartPageItems = document.querySelector('#main-cart-items');
        const cartPageSectionId = cartPageItems?.dataset?.id;

        if (this.form) {
          const quantityInput = this.form.quantity;
          const maxQuantity = quantityInput && quantityInput.max !== '' ? parseInt(quantityInput.max, 10) : null;
          const requestedQuantity = quantityInput ? parseInt(quantityInput.value, 10) : 1;

          if (quantityInput && Number.isFinite(maxQuantity) && (maxQuantity < 1 || requestedQuantity > maxQuantity)) {
            quantityInput.value = Math.max(maxQuantity, 0);
            this.handleErrorMessage(
              maxQuantity < 1
                ? "That's all we have in stock."
                : `Only ${maxQuantity} item${maxQuantity === 1 ? '' : 's'} can be added due to availability.`
            );

            if (maxQuantity < 1) {
              this.adding = false;
              this.submitButtonText.textContent = this.defaultSubmitButtonText;
              if (stickySubmitButtonText) stickySubmitButtonText.textContent = defaultStickySubmitButtonText;
              return;
            }
          }
        }
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              if (response.status === 422) {
                refreshCartDrawer();
              }
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              if (!soldOutMessage.textContent.trim() && soldOutMessage.dataset.soldOutText) {
                soldOutMessage.textContent = soldOutMessage.dataset.soldOutText;
              }
              soldOutMessage.hidden = false;
              soldOutMessage.removeAttribute('aria-hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (!cartPageSectionId) return;

              fetch(`${routes.cart_url}?section_id=${cartPageSectionId}`)
                .then((sectionResponse) => sectionResponse.text())
                .then((sectionHtml) => {
                  const parsedSection = new DOMParser().parseFromString(sectionHtml, 'text/html');
                  const updatedItems = parsedSection.querySelector('#main-cart-items .js-contents');
                  const currentItems = document.querySelector('#main-cart-items .js-contents');
                  const updatedFooter = parsedSection.querySelector('#detailed-cart-footer');
                  const currentFooter = document.querySelector('#detailed-cart-footer');

                  if (updatedItems && currentItems) currentItems.innerHTML = updatedItems.innerHTML;
                  if (updatedFooter && currentFooter) currentFooter.innerHTML = updatedFooter.innerHTML;
                })
                .catch((error) => console.error('[Cart] Cart page refresh error:', error));
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const addedTitle =
              response.product_title ||
              document.querySelector('.product__title h1, .product__title .h1, h1')?.textContent.trim() ||
              '';
            if (window.DistaA11y && window.distaA11yStrings?.addedToCart) {
              window.DistaA11y.announce(window.distaA11yStrings.addedToCart.replace('__PRODUCT__', addedTitle));
            }
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
                if (document.getElementById('sticky-atc-quantity')) {
                  document.getElementById('sticky-atc-quantity').value = 1;
                }
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (!this.error) this.submitButtonText.textContent = this.defaultSubmitButtonText;
            if (!this.error && stickySubmitButtonText) {
              stickySubmitButtonText.textContent = defaultStickySubmitButtonText;
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.adding = false;
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

handleErrorMessage(errorMessage = false) {
  if (this.hideErrors) return;

  this.errorMessageWrapper =
    this.errorMessageWrapper ||
    this.querySelector('.product-form__error-message-wrapper');

  if (!this.errorMessageWrapper) return;

  this.errorMessage =
    this.errorMessage ||
    this.errorMessageWrapper.querySelector('.product-form__error-message');

  // Clear previous hide timer
  clearTimeout(this.errorMessageHideTimer);

  if (errorMessage) {
    // Show the error again
    this.errorMessageWrapper.style.display = 'flex';
    this.errorMessageWrapper.toggleAttribute('hidden', false);

    this.errorMessage.textContent = errorMessage;

    this.errorMessageWrapper.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    // Hide after 6 seconds
    this.errorMessageHideTimer = setTimeout(() => {
      this.errorMessageWrapper.style.display = 'none';
    }, 6000);
  } else {
    this.errorMessageWrapper.toggleAttribute('hidden', true);
    this.errorMessageWrapper.style.display = 'none';
  }
}

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
